var React = require('react');

function CheckmarkTaskInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.3801 9.28564L14.3563 26.3095L6.61816 18.5714","stroke":"black","strokeWidth":"2.78571","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckmarkTaskInline.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = CheckmarkTaskInline;

CheckmarkTaskInline.default = CheckmarkTaskInline;
